module.exports = __webpack_public_path__ + "static/media/eSigning.499bfed5.png";